// Klaviyo Reviews Tag Buttons
// Creates "Energy" and "Hydration" buttons inside kl_reviews__summary__rating--1
// When clicked, sets the search input value to the button text

(function() {
  // Only execute if klaviyo-reviews-all exists
  if (!document.querySelector('#klaviyo-reviews-all')) {
    return;
  }

  function initTagButtons() {
    const ratingContainer = document.querySelector('.kl_reviews__summary__rating--1');
    const searchInput = document.querySelector('.kl_reviews__search input');
    
    // Check if elements exist
    if (!ratingContainer || !searchInput) {
      return;
    }

    // Check if wrapper already exists to prevent duplicates
    if (ratingContainer.querySelector('.kl-tag-buttons-wrapper')) {
      return;
    }

    // Create wrapper div
    const wrapperDiv = document.createElement('div');
    wrapperDiv.className = 'kl-tag-buttons-wrapper';
    
    // Create title
    const title = document.createElement('p');
    title.className = 'kl-tag-buttons-title';
    title.textContent = 'Selected Tags:';
    wrapperDiv.appendChild(title);
    
    // Create buttons container
    const buttonsContainer = document.createElement('div');
    buttonsContainer.className = 'kl-tag-buttons-container';
    
    // Create buttons
    const buttons = ['Energy', 'Hydration'];
    
    buttons.forEach(buttonText => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kl-tag-button';
      button.textContent = buttonText;
      
      // Add click event listener
      button.addEventListener('click', function() {
        if (searchInput) {
          searchInput.value = buttonText;
          
          // Trigger input event to ensure any listeners are notified
          const inputEvent = new Event('input', { bubbles: true });
          searchInput.dispatchEvent(inputEvent);
          
          // Trigger change event as well
          const changeEvent = new Event('change', { bubbles: true });
          searchInput.dispatchEvent(changeEvent);
        }
      });
      
      // Append button to buttons container
      buttonsContainer.appendChild(button);
    });
    
    // Append buttons container to wrapper
    wrapperDiv.appendChild(buttonsContainer);
    
    // Append wrapper to rating container
    ratingContainer.appendChild(wrapperDiv);
  }

  // Try to initialize immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Use MutationObserver to wait for the elements to be available
      const observer = new MutationObserver(function(mutations, obs) {
        const ratingContainer = document.querySelector('.kl_reviews__summary__rating--1');
        const searchInput = document.querySelector('.kl_reviews__search input');
        
        if (ratingContainer && searchInput) {
          initTagButtons();
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Also try immediately
      setTimeout(initTagButtons, 100);
    });
  } else {
    // Use MutationObserver to wait for the elements to be available
    const observer = new MutationObserver(function(mutations, obs) {
      const ratingContainer = document.querySelector('.kl_reviews__summary__rating--1');
      const searchInput = document.querySelector('.kl_reviews__search input');
      
      if (ratingContainer && searchInput) {
        initTagButtons();
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also try immediately
    setTimeout(initTagButtons, 100);
  }
})();

